import { createSlice } from '@reduxjs/toolkit';

const idleSlice = createSlice({
  name: 'idle',
  initialState: {
    isIdle: false, // Estado inicial
  },
  reducers: {
    setIdle: (state, action) => {
      state.isIdle = action.payload; // Actualiza el estado de inactividad
    },
  },
});

export const { setIdle } = idleSlice.actions;
export default idleSlice.reducer;